import { DISABLE_FAMILY_PRODUCT_FORM_LOADER } from "../../modules/user/constants";
import {
  DISABLE_CALCUL_LOADER,
  DISABLE_REPORTS_LOADERS,
  ENABLE_CALCUL_LOADER,
  ENABLE_REPORTS_LOADERS,
  ENABLE_DOWNLOAD_REPORTS_LOADER,
  DISABLE_DOWNLOAD_REPORTS_LOADER,
} from "../../modules/family-product/constants";
import { DISABLE_GROUP_FORM_LOADER } from "../../modules/manage-group/constants";
import { DISABLE_TABLE_SCROLL, ENABLE_TABLE_SCROLL } from "../constants/loader";

export function disableFamilyProductFormLoader() {
  return {
    type: DISABLE_FAMILY_PRODUCT_FORM_LOADER,
  };
}

export function disableGroupFormLoader() {
  return {
    type: DISABLE_GROUP_FORM_LOADER,
  };
}

export function enableReportsLoaders(calculIds) {
  return {
    type: ENABLE_REPORTS_LOADERS,
    calculIds,
  };
}

export function disableReportsLoaders() {
  return {
    type: DISABLE_REPORTS_LOADERS,
  };
}

export function enableCalculLoader() {
  return {
    type: ENABLE_CALCUL_LOADER,
  };
}

export function disableCalculLoader() {
  return {
    type: DISABLE_CALCUL_LOADER,
  };
}

export function disableTableScroll() {
  return {
    type: DISABLE_TABLE_SCROLL,
  };
}

export function enableTableScroll() {
  return {
    type: ENABLE_TABLE_SCROLL,
  };
}

export function enableDownloadReportsLoader() {
  return {
    type: ENABLE_DOWNLOAD_REPORTS_LOADER,
  };
}

export function disableDownloadReportsLoader() {
  return {
    type: DISABLE_DOWNLOAD_REPORTS_LOADER,
  };
}
